import React, { PureComponent } from 'react';
import * as _ from 'lodash';
import { connect } from 'shalala';
import { Guardian } from '@xaamin/guardian';
import { Dropdown, ButtonGroup } from 'react-bootstrap';

import { useStore } from '../../../../store';
import LoadingButton from '../../../../facturotopia/LoadingButton';

class PacsItemActions extends PureComponent {
  prioritize = () => {
    const { pacs, selectedRowKeys } = this.props;

    let newPacs = pacs.map((item) => {
      item = { ...item };

      if (selectedRowKeys[0] === item.id) {
        item.prioridad = -100000;
      }

      return item;
    });

    this.priority(newPacs);
  };

  penalize = () => {
    const { pacs, selectedRowKeys } = this.props;

    let newPacs = pacs.map((item) => {
      item = { ...item };

      if (selectedRowKeys[0] === item.id) {
        item.prioridad = 100000;
      }

      return item;
    });

    this.priority(newPacs);
  };

  priority = async (newPacs) => {
    newPacs = _.orderBy(newPacs, 'prioridad').map((value, index) => {
      value = { ...value };

      value.prioridad = index * 10 || 1;

      return value;
    });

    for (const pac of newPacs) {
      await this.props.pac.upsert(
        {
          prioridad: pac.prioridad,
          alias: pac.alias,
          nombre: pac.nombre,
        },
        pac.id
      );
    }

    await this.props.paginate();
  };

  activate = () => {
    this.upsert({
      status: 1,
      comentario: 'Activado desde ui',
    });
  };

  sandbox = () => {
    this.upsert({
      status: 2,
      comentario: 'Sandbox desde ui',
    });
  };

  manual = () => {
    this.upsert({
      status: 5,
      comentario: 'Manual desde ui',
    });
  };

  suspend = () => {
    this.upsert({
      status: 0,
      comentario: 'Suspendido desde ui',
    });
  };

  enabledCancel = () => {
    this.upsert({
      cancellation: 1,
      comentario: 'Activar cancelación desde ui',
    });
  };

  disabledCancel = () => {
    this.upsert({
      cancellation: 0,
      comentario: 'Desactivar cancelación desde ui',
    });
  };

  upsert = async (data) => {
    const { selectedRows } = this.props;
    const pac = selectedRows[0];

    await this.props.pac.upsert(data, pac.id);

    await this.props.paginate();
  };

  config = async () => {
    const { selectedRows } = this.props;
    const pac = selectedRows[0];

    await this.props.config({
      entry: 'facturotopia.default',
      value: pac.alias,
    });
  };

  render() {
    const { selectedRows, selectedRowKeys, busy } = this.props;

    if (busy) {
      return (
        <LoadingButton
          loading={busy}
          variant="secondary"
        >
          Procesando
        </LoadingButton>
      );
    }

    const display = selectedRowKeys.length === 1;

    return (
      <Dropdown
        as={ButtonGroup}
        alignRight={true}
      >
        <Dropdown.Toggle
          variant="secondary"
          id="dropdown-basic"
        >
          Acciones{' '}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {display && [0, 2, 5].indexOf(selectedRows[0].status) !== -1 && (
            <>
              {Guardian.allows('pac.activar') && (
                <Dropdown.Item
                  as="div"
                  onClick={this.activate}
                >
                  Activar
                </Dropdown.Item>
              )}
            </>
          )}

          {display && (
            <>
              {Guardian.allows('pac.priorizar') && (
                <Dropdown.Item
                  as="div"
                  onClick={this.prioritize}
                >
                  Priorizar
                </Dropdown.Item>
              )}

              {Guardian.allows('pac.principal') && (
                <Dropdown.Item
                  as="div"
                  onClick={this.config}
                >
                  Pac Principal
                </Dropdown.Item>
              )}

              {<Dropdown.Divider />}

              {Guardian.allows('pac.penalizar') && (
                <Dropdown.Item
                  as="div"
                  onClick={this.penalize}
                >
                  Penalizar
                </Dropdown.Item>
              )}

              {Guardian.allows('pac.suspender') && (
                <Dropdown.Item
                  as="div"
                  onClick={this.suspend}
                >
                  Suspender
                </Dropdown.Item>
              )}

              {Guardian.allows('pac.sandbox') && (
                <Dropdown.Item
                  as="div"
                  onClick={this.sandbox}
                >
                  Solo sandbox
                </Dropdown.Item>
              )}

              <Dropdown.Item
                as="div"
                onClick={this.manual}
              >
                Manual
              </Dropdown.Item>

              {<Dropdown.Divider />}

              {[0].indexOf(selectedRows[0].cancellations) !== -1 && (
                <>
                  <Dropdown.Item
                    as="div"
                    onClick={this.enabledCancel}
                  >
                    Activar cancelación
                  </Dropdown.Item>
                </>
              )}

              {[1].indexOf(selectedRows[0].cancellations) !== -1 && (
                <>
                  <Dropdown.Item
                    as="div"
                    onClick={this.disabledCancel}
                  >
                    Desactivar cancelación
                  </Dropdown.Item>
                </>
              )}
            </>
          )}

          {/* <Dropdown.Item
            as="div"
            onClick={ this.block }
          >
            Bloqueo temporal
          </Dropdown.Item> */}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

const mapState = (state) => {
  return {
    ...state.admin.pacs.upsert,
    pacs: state.admin.pacs.list.data,
  };
};

const mapActions = (actions) => {
  return {
    pac: actions.admin.pacs.upsert,
    paginate: actions.admin.pacs.list.paginate,
    config: actions.admin.config.upsert.upsert,
  };
};

export default connect(useStore, mapState, mapActions)(PacsItemActions);
